import "supplemental-prototype";
import "@ubnt/ui-components/styles/variables.css";

import React, { Fragment } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { CssVariableProviderSSR } from "@ubnt/ui-components/ThemeContext";

import App from "layout/App";
import ScrollToTop from "util/ScrollToTop";

import { theme, GlobalStyle } from "layout";
import { SiteSettingsProvider } from "./context/SiteSettingsContext";
import { AppProvider } from "./context/AppContext";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

const root = createRoot(rootElement);

root.render(
  <CssVariableProviderSSR>
    <AppProvider>
      <Router>
        <ScrollToTop>
          <SiteSettingsProvider>
            <ThemeProvider theme={theme}>
              <Fragment>
                <App />
                <GlobalStyle />
              </Fragment>
            </ThemeProvider>
          </SiteSettingsProvider>
        </ScrollToTop>
      </Router>
    </AppProvider>
  </CssVariableProviderSSR>,
);
